
//export const LOADING_JOBS= 'loading_jobs';
/**
 * @format
 */
 export const TOGGLE_AC_CANDIDATE_LOADING = 'toggle_ap_candidate_loading';
